import { useCallback, useEffect, useState } from "react";
import { FyCycleOption } from "../models/audit/fyCycleOption";
import { getFyCycleOptions } from "../api/fyCycleOptions";

export function useFyCycleOptions() {
  const [options, setOptions] = useState<FyCycleOption[]>([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getFyCycleOptions();
      setOptions(data);
      return data;
    } catch (error) {
      console.error("Failed to fetch FY cycle options:", error);
      return undefined;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { options, loading, refetch: fetch };
}
